export const TaskActionTypes = {
  SET_TASKS: 'SET_TASKS',
  SET_TASK: 'SET_TASK',
  SET_UNFINISHED_TASK: "SET_UNFINISHED_TASK",
  SET_FINISHED_TASKS_TODAY: 'SET_FINISHED_TASKS_TODAY',
  SET_SUCCESSFUL_TASKS_TODAY: 'SET_SUCCESSFUL_TASKS_TODAY'
};
